var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBillingSizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3678_834)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86537 6H17.1346C18.8568 6 20.25 7.36644 20.25 9.04433V14.9556C20.25 16.6335 18.8568 17.9999 17.1346 17.9999H6.86537C5.14314 17.9999 3.75 16.6335 3.75 14.9556V9.04433C3.75 7.36644 5.14314 6 6.86537 6ZM4.80023 9.37785H19.1998V9.04433C19.1998 7.92698 18.2703 7.02181 17.1346 7.02181H6.86537C5.72968 7.02181 4.80023 7.92698 4.80023 9.04433V9.37785ZM19.1998 10.3997H4.80023V14.9556C4.80023 16.0729 5.72968 16.9781 6.86537 16.9781H17.1346C18.2703 16.9781 19.1998 16.0729 19.1998 14.9556V10.3997Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41522 13.8003H10.5843C10.9473 13.8003 11.2497 14.0729 11.2497 14.4003C11.2497 14.7277 10.9473 15.0003 10.5843 15.0003H7.41522C7.05212 15.0003 6.74973 14.7277 6.74973 14.4003C6.74973 14.0729 7.05212 13.8003 7.41522 13.8003Z",
    fill: "#2E3A59"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3678_834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingSizer);
export default __webpack_public_path__ + "static/media/billingSizer.93e530fa.svg";
export { ForwardRef as ReactComponent };